export enum SystemNoticeTypeEnum {
  /** A snack bar at the bottom of the screen - title and description only, no image. */
  Toast = 0,
  /** A modal that blocks the app until dismissed and can show an image above the text. */
  Popup = 1
}
